import React from 'react';
import CardBalanceDepositar from '../../../card/CardBalanceDepositar'
import Col from '../../../../assets/currency/copu.png'
import Usd from '../../../../assets/currency/usd.png'




const SelectWallet = ({

  balanceCop,
  labelCop = "Pesos Colombianos",
  balanceUsd,
  labelUsd = "Dólares Estadounidenses",
  ClickWalletCop,
  ClickWalletUsd
}) => {

  return (
    <>
      <p className='w-full flex mt-4 text-base font-normal text-[#B7B7B9] traking-[-0.14px] leading-5 ' >Selecciona la billetera donde deseas depositar:</p>
      <div className='w-full h-full flex items-center gap-2 justify-center py-4  ' >
        <CardBalanceDepositar icon={Col} balance={balanceCop} textBalance={`text-[16px]`} textLabel={'text-[20px] mb-1'} className={``} hover={false} label={labelCop} onClick={ClickWalletCop} />
        <CardBalanceDepositar icon={Usd} balance={balanceUsd} textBalance={`text-[16px]`} textLabel={'text-[20px] mb-1'} hover={false} label={labelUsd} onClick={ClickWalletUsd} />
      </div>
    </>
  );
};

export default SelectWallet;